/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jul 22 2024
 **/

import { makeAPI } from "@/frameworks/core/API";
import AdminSpaceService from "./api";

export default function withSpace(events: API.Events) {
	return {
		spaceDetail: makeAPI<WebServices.UserAdmin.Space.Detail.Response>(
			AdminSpaceService.space.detail("spaceDetail", events)
		),
		spaceList: makeAPI<WebServices.UserAdmin.Space.List.Response>(
			AdminSpaceService.space.spaceList("spaceList", events)
		),
		spaceUserList: makeAPI<WebServices.UserAdmin.Space.UserList.Response>(
			AdminSpaceService.space.spaceUserList("spaceUserList", events)
		),
		spaceChatList: makeAPI<WebServices.UserAdmin.Space.Chat.List.Response>(
			AdminSpaceService.space.spaceChatList("spaceChatList", events)
		),
		createSpace: makeAPI<WebServices.UserAdmin.Space.Create.Response>(
			AdminSpaceService.space.createSpace("createSpace", events)
		),
		deleteSpace: makeAPI<WebServices.UserAdmin.Space.Delete.Response>(
			AdminSpaceService.space.deleteSpace("deleteSpace", events)
		),
		deleteSpaceChannel: makeAPI<WebServices.UserAdmin.Space.Chat.DeleteChannel.Response>(
			AdminSpaceService.space.deleteSpaceChannel("deleteSpaceChannel", events)
		)
	};
}
